import { DestroyRef, DOCUMENT, inject, provideEnvironmentInitializer } from '@angular/core';
import { debounceTime, Observable } from 'rxjs';

export function isInIframe(): boolean {
  try {
    return window.self !== window.top; //NOSONAR
  } catch {
    return true;
  }
}

export function getEmbedderInfo() {
  return {
    isEmbedded: isInIframe(),
    referrer: document.referrer || null,
    origin: document.referrer ? new URL(document.referrer).origin : null,
  };
}

function notifyParentResize(): void {
  const height = document.documentElement.scrollHeight;
  window.parent.postMessage({ type: 'fido-resize', height }, '*'); //NOSONAR
}

function createResizeObservable(element: Element): Observable<ResizeObserverEntry[]> {
  return new Observable((subscriber) => {
    const observer = new ResizeObserver((entries) => {
      subscriber.next(entries);
    });
    observer.observe(element);
    return () => observer.disconnect();
  });
}

export function provideResizeNotificationsForEmbedded() {
  return provideEnvironmentInitializer(() => {
    const document = inject(DOCUMENT);
    const window = document.defaultView;
    const destroyRef = inject(DestroyRef);

    if (!window || !isInIframe()) return;

    notifyParentResize();

    const subscription = createResizeObservable(document.body)
      .pipe(debounceTime(150))
      .subscribe(() => notifyParentResize());

    destroyRef.onDestroy(() => subscription.unsubscribe());
  });
}
